
import { useRef } from "react";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { useLanguage } from "@/contexts/LanguageContext";

const HeroSection = () => {
  const elementsRef = useRef<(HTMLDivElement | null)[]>([]);
  const { t } = useLanguage();
  
  return <section className="relative min-h-[80vh] flex items-center justify-center overflow-hidden">
      {/* Background gradient - with proper dark mode support */}
      <div className="absolute inset-0 bg-gradient-to-b from-green-50 to-white dark:from-gray-900 dark:to-gray-950 -z-10"></div>
      
      {/* Animated shapes - with better dark mode visibility */}
      <div className="absolute top-1/4 -right-20 w-96 h-96 bg-green-200/30 dark:bg-green-700/20 rounded-full filter blur-3xl animate-float"></div>
      <div className="absolute bottom-1/4 -left-20 w-72 h-72 bg-blue-200/30 dark:bg-blue-700/20 rounded-full filter blur-3xl animate-float animation-delay-300"></div>
      
      <div className="container mx-auto px-6 py-20 md:py-32">
        <div className="max-w-3xl mx-auto text-center">
          {/* Logo display above the heading */}
          <div className="mb-8 flex justify-center reveal-on-scroll">
            <img 
              src="https://sooovuvamgyafqsqehbo.supabase.co/storage/v1/object/public/images/logo.png" 
              alt="BlueTech Logo" 
              className="w-24 h-24"
              width="96"
              height="96"
              loading="eager"
            />
          </div>
          
          <h1 ref={el => elementsRef.current[0] = el} className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 reveal-on-scroll dark:text-white">
            {t('hero_title')}
          </h1>
          
          <p ref={el => elementsRef.current[1] = el} className="text-lg md:text-xl text-gray-700 dark:text-gray-300 mb-8 reveal-on-scroll">
            {t('hero_subtitle1')}
          </p>

          <p ref={el => elementsRef.current[2] = el} className="text-lg md:text-xl text-gray-700 dark:text-gray-300 mb-10 reveal-on-scroll">
            {t('hero_subtitle2')}
          </p>
          
          <div ref={el => elementsRef.current[3] = el} className="flex flex-col sm:flex-row gap-4 justify-center mt-8 reveal-on-scroll">
            <Link to="/arbitrinity">
              <Button size="lg" className="bg-primary hover:bg-primary/90 text-white gap-2">
                {t('hero_cta_arbitrinity')}
                <ArrowRight className="w-4 h-4" />
              </Button>
            </Link>
            <Button size="lg" variant="outline" className="border-primary/20 hover:bg-primary/5 dark:border-gray-700 dark:text-gray-200 dark:hover:bg-gray-800/50">
              <a href="#contact">{t('hero_cta_contact')}</a>
            </Button>
          </div>
        </div>
      </div>
    </section>;
};

export default HeroSection;
